module.exports = __webpack_public_path__ + "img/invoice-de-male-nw.bcfe18eb.png";